import { Controller } from '@hotwired/stimulus'

// Copies the text in the "source" target (or a static value) to the
// clipboard and briefly shows a "Copied!" confirmation. Used on the color
// swatches so designers/devs can grab a hex value quickly.
export default class extends Controller {
  static targets = ['source', 'label']
  static values = { text: String, copiedLabel: { type: String, default: 'Copied!' } }

  async copy() {
    const text = this.hasTextValue && this.textValue
      ? this.textValue
      : this.sourceTarget.textContent.trim()

    try {
      await navigator.clipboard.writeText(text)
    } catch (error) {
      // Fallback for browsers/contexts without Clipboard API access.
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }

    this.showCopiedState()
  }

  showCopiedState() {
    if (!this.hasLabelTarget) return

    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.copiedLabelValue

    clearTimeout(this.resetTimeout)
    this.resetTimeout = setTimeout(() => {
      this.labelTarget.textContent = original
    }, 1200)
  }
}
